import { ProgrammationPDFSettings } from '@teetsh/app/src/types/programmations';
import { PrintConfig } from '../types';
import _isEmpty from 'lodash-es/isEmpty';

interface Props {
  hiddenPeriodes: string;
  hiddenDomaines: string;
  printConfig: PrintConfig;
  matiereIds: string;
  hideTitle: boolean;
  settings: ProgrammationPDFSettings;
}

export function buildProgPDFParams({
  hiddenPeriodes,
  hiddenDomaines,
  printConfig,
  matiereIds,
  hideTitle,
  settings,
}: Props) {
  const params = new URLSearchParams({
    view: printConfig.view,
    matiereIds,
  });
  if (!_isEmpty(hiddenPeriodes)) {
    params.set('hiddenPeriodes', hiddenPeriodes);
  }
  if (!_isEmpty(hiddenDomaines)) {
    params.set('hiddenDomaines', hiddenDomaines);
  }
  const searchParams = new URLSearchParams(window.location.search);
  const title = searchParams.get('title');

  if (hideTitle !== undefined) {
    params.set('hideTitle', hideTitle.toString());
  }
  if (title) {
    params.set('title', title);
  }

  params.set('rowTitleOrientation', printConfig.rowTitleOrientation);
  params.set('editableTitle', true.toString());
  params.set('breakBefore', printConfig.breakBefore.toString());
  params.set(
    'groupWeeksByPeriodes',
    printConfig.groupWeeksByPeriodes.toString(),
  );
  if (settings.size) {
    params.set('fontSize', settings?.size.toString() || '14');
  }
  if (settings.bgColor) {
    params.set('bgColor', settings?.bgColor || 'white');
  }
  if (settings.marginTop !== undefined) {
    params.set('marginTop', settings?.marginTop.toString() || '10');
  }
  if (settings.marginBottom !== undefined) {
    params.set('marginBottom', settings?.marginBottom.toString() || '10');
  }
  if (settings.marginLeft !== undefined) {
    params.set('marginLeft', settings?.marginLeft.toString() || '10');
  }
  if (settings.marginRight !== undefined) {
    params.set('marginRight', settings?.marginRight.toString() || '10');
  }
  if (settings.font) {
    params.set('font', settings?.font || 'Roboto');
  }

  return params;
}
